import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Params
} from '@angular/router';

import { SessionService } from '../session/session.service';
import { TokenService } from '../../authentication/token.service';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from 'app/authentication/authentication.service';
import { tap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(
    private tokenService: TokenService,
    private auth: AuthenticationService,
    private router: Router,
    private session: SessionService
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    if (
      environment.enableSSO &&
      !(!!location.search && /(token|username)/.test(location.search))
    ) {
      if (this.tokenService.hasToken()) {
        return true;
      } else if (!!location.search && /(partner)/.test(location.search)) {
        this.router.navigate(['/login/partner'], {
          queryParams: this.parseSearchString(location.search)
        });
      } else {
        return this.auth.loginSSO().pipe(
          tap(token => {
            this.session.redirectTo = router.url;
            this.session.createSession(token);
          }),
          map(token => !!token)
        );
      }
    } else if (this.tokenService.hasToken()) {
      return true;
    } else if (!!location.search && /(token|username)/.test(location.search)) {
      this.router.navigate(['/login/external'], {
        queryParams: this.parseSearchString(location.search)
      });
    } else if (!!sessionStorage.getItem('apitoken')) {
      this.session.redirectTo = router.url;
      this.session.createSession(sessionStorage.getItem('apitoken'), false);
    } else {
      this.session.redirectTo = router.url;
      location.href = `${location.origin.replace('-web', '')}${
        environment.authService
      }${window.location.hostname === 'localhost' ? '?local=true' : ''}`;
    }

    if (route) {
      return false;
    }

    return false;
  }

  public parseSearchString(query: string): Params {
    const params: Params = {};
    query = query
      .trim()
      .replace(/^[?#&]/, '')
      .replace(/[&]$/, '');
    query.split('&').forEach((part: string) => {
      const parts: Array<string> = part.split('=');
      if (parts.length === 2) {
        params[parts[0]] = decodeURIComponent(parts[1].replace(/\+/g, ''));
      }
    });
    return params;
  }
}
